import React, { useState, useEffect } from "react";
import axios from "axios";
import authHeader from "../services/auth-header";
import Chart from "./Chart";

const App = (props) => {
  /************************* USE STATE ************************/

  const [chart, setChart] = useState({});
  const [cpdatas, setCpdatas] = useState([]);
  const [messages, setMessages] = useState([]);
  const [showdata, setShowdata] = useState([]);

  /*************************FUNCTIONS************************/

  function clearGraph() {
    setChart({
      datasets: [],
    });
    messages.message = "";
    props.onClick();
  }

  const handleDevice = (event) => {
    setShowdata(event.target.value);
  };

  /*************************IMPORT DATA FROM OTHER PAGE************************/

  useEffect(() => {
    getData(props.url);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // /*eslint-disable*/
  }, [props.url]);
  // console.log(props.url)

  const getData = async () => {
    try {
      const res = await axios({
        method: "get",
        url: props.url,
        headers: authHeader(),
      });
      setCpdatas(res.data.raw_imei);
      setMessages(res.data);
      setChart({
        labels: Object.values(
          res.data.raw_imei[0].values.map((obj) =>
            obj.dt_time.$date.slice(0, 16)
          )
        ),
        datasets: [
          {
            label: "raw1",
            fill: false,
            lineTension: 0.1,
            backgroundColor: "rgba(75,192,192,0.4)",
            borderColor: "rgb(255, 0, 0)",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "rgba(75,192,192,1)",
            pointBackgroundColor: "#fff",
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: "rgba(75,192,192,1)",
            pointHoverBorderColor: "rgba(220,220,220,1)",
            pointHoverBorderWidth: 2,
            pointRadius: 3,
            pointHitRadius: 10,
            data: Object.values(
              res.data.raw_imei.map((obj) => obj.values).length >= 1
                ? res.data.raw_imei[0].values.map((obj) => obj["raw"])
                : []
            ),
          },
          {
            label: "raw2",
            fill: false,
            lineTension: 0.1,
            backgroundColor: "rgba(75,192,192,0.4)",
            borderColor: "rgb(255, 255, 0)",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "rgba(75,192,192,1)",
            pointBackgroundColor: "#fff",
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: "rgba(75,192,192,1)",
            pointHoverBorderColor: "rgba(220,220,220,1)",
            pointHoverBorderWidth: 2,
            pointRadius: 3,
            pointHitRadius: 10,
            data: Object.values(
              res.data.raw_imei.map((obj) => obj.values).length >= 2
                ? res.data.raw_imei[1].values.map((obj) => obj["raw"])
                : []
            ),
          },
          {
            label: "raw3",
            fill: false,
            lineTension: 0.1,
            backgroundColor: "rgba(75,192,192,0.4)",
            borderColor: "rgb(0, 255, 38)",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "rgba(75,192,192,1)",
            pointBackgroundColor: "#fff",
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: "rgba(75,192,192,1)",
            pointHoverBorderColor: "rgba(220,220,220,1)",
            pointHoverBorderWidth: 2,
            pointRadius: 3,
            pointHitRadius: 10,
            data: Object.values(
              res.data.raw_imei.map((obj) => obj.values).length >= 3
                ? res.data.raw_imei[2].values.map((obj) => obj["raw"])
                : []
            ),
          },
          {
            label: "raw4",
            fill: false,
            lineTension: 0.1,
            backgroundColor: "rgba(75,192,192,0.4)",
            borderColor: "rgb(0, 247, 255)",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "rgba(75,192,192,1)",
            pointBackgroundColor: "#fff",
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: "rgba(75,192,192,1)",
            pointHoverBorderColor: "rgba(220,220,220,1)",
            pointHoverBorderWidth: 2,
            pointRadius: 3,
            pointHitRadius: 10,
            data: Object.values(
              res.data.raw_imei.map((obj) => obj.values).length >= 4
                ? res.data.raw_imei[3].values.map((obj) => obj["raw"])
                : []
            ),
          },
          {
            label: "raw5",
            fill: false,
            lineTension: 0.1,
            backgroundColor: "rgba(75,192,192,0.4)",
            borderColor: "rgb(255, 0, 255)",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "rgba(75,192,192,1)",
            pointBackgroundColor: "#fff",
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: "rgba(75,192,192,1)",
            pointHoverBorderColor: "rgba(220,220,220,1)",
            pointHoverBorderWidth: 2,
            pointRadius: 3,
            pointHitRadius: 10,
            data: Object.values(
              res.data.raw_imei.map((obj) => obj.values).length >= 5
                ? res.data.raw_imei[4].values.map((obj) => obj["raw"])
                : []
            ),
          },
          {
            label: "calib1",
            fill: false,
            lineTension: 0.1,
            backgroundColor: "rgba(75,192,192,0.4)",
            borderColor: "rgb(230, 140, 140)",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "rgba(75,192,192,1)",
            pointBackgroundColor: "#fff",
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: "rgba(75,192,192,1)",
            pointHoverBorderColor: "rgba(220,220,220,1)",
            pointHoverBorderWidth: 2,
            pointRadius: 3,
            pointHitRadius: 10,
            data: Object.values(
              res.data.raw_imei.map((obj) => obj.values).length >= 1
                ? res.data.raw_imei[0].values.map((obj) => obj["calib"])
                : []
            ),
          },
          {
            label: "calib2",
            fill: false,
            lineTension: 0.1,
            backgroundColor: "rgba(75,192,192,0.4)",
            borderColor: "rgb(230, 230, 140)",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "rgba(75,192,192,1)",
            pointBackgroundColor: "#fff",
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: "rgba(75,192,192,1)",
            pointHoverBorderColor: "rgba(220,220,220,1)",
            pointHoverBorderWidth: 2,
            pointRadius: 3,
            pointHitRadius: 10,
            data: Object.values(
              res.data.raw_imei.map((obj) => obj.values).length >= 2
                ? res.data.raw_imei[1].values.map((obj) => obj["calib"])
                : []
            ),
          },
          {
            label: "calib3",
            fill: false,
            lineTension: 0.1,
            backgroundColor: "rgba(75,192,192,0.4)",
            borderColor: "rgb(140, 230, 157)",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "rgba(75,192,192,1)",
            pointBackgroundColor: "#fff",
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: "rgba(75,192,192,1)",
            pointHoverBorderColor: "rgba(220,220,220,1)",
            pointHoverBorderWidth: 2,
            pointRadius: 3,
            pointHitRadius: 10,
            data: Object.values(
              res.data.raw_imei.map((obj) => obj.values).length >= 3
                ? res.data.raw_imei[2].values.map((obj) => obj["calib"])
                : []
            ),
          },
          {
            label: "calib4",
            fill: false,
            lineTension: 0.1,
            backgroundColor: "rgba(75,192,192,0.4)",
            borderColor: "rgb(140, 217, 230)",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "rgba(75,192,192,1)",
            pointBackgroundColor: "#fff",
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: "rgba(75,192,192,1)",
            pointHoverBorderColor: "rgba(220,220,220,1)",
            pointHoverBorderWidth: 2,
            pointRadius: 3,
            pointHitRadius: 10,
            data: Object.values(
              res.data.raw_imei.map((obj) => obj.values).length >= 4
                ? res.data.raw_imei[3].values.map((obj) => obj["calib"])
                : []
            ),
          },
          {
            label: "calib5",
            fill: false,
            lineTension: 0.1,
            backgroundColor: "rgba(75,192,192,0.4)",
            borderColor: "rgb(230, 140, 221)",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "rgba(75,192,192,1)",
            pointBackgroundColor: "#fff",
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: "rgba(75,192,192,1)",
            pointHoverBorderColor: "rgba(220,220,220,1)",
            pointHoverBorderWidth: 2,
            pointRadius: 3,
            pointHitRadius: 10,
            data: Object.values(
              res.data.raw_imei.map((obj) => obj.values).length >= 5
                ? res.data.raw_imei[4].values.map((obj) => obj["calib"])
                : []
            ),
          },
          {
            label: "ref",
            fill: false,
            lineTension: 0.1,
            backgroundColor: "rgb(75,192,192,0.4)",
            borderColor: "rgb(0, 0, 0)",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "rgb(229, 46, 46)",
            pointBackgroundColor: "#fff",
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: "rgb(229, 46, 46)",
            pointHoverBorderColor: "rgba(220,220,220,1)",
            pointHoverBorderWidth: 2,
            pointRadius: 3,
            pointHitRadius: 10,
            data: Object.values(
              res.data.refrence_imei[0].values.map((obj) => obj["ref"])
            ),
          },
        ],
      });
    } catch (error) {
      // console.log(error);
    }
  };

  let cpdatasRender;

  const startData = (
    <div
      className="row mr-4 mt-4 ml-4 pb-4"
      style={{ backgroundColor: "white" }}
    >
      <div className="col-8">
        <Chart data1={chart} />
      </div>
      <div className="col-4 col chart-graph-initial-text">
        <div className="top">
          <p className="head-text">Correlation Performance</p>
          <select
            className="custom-select-btn"
            value={showdata}
            onChange={handleDevice}
          >
            <option value="select">Select Device</option>
            {props.selectedOption.map((e) => (
              <option key={e.label}>{e.label}</option>
            ))}
          </select>
        </div>

        <div className="bottom">
          <p>To see input select device from the dropdown box.</p>
          <button className="chart-graph-button" onClick={clearGraph}>
            <p>Clear Graph & Input</p>
          </button>
        </div>
      </div>
    </div>
  );

  if (messages.message === "successful") {
    cpdatasRender =
      cpdatas !== undefined
        ? cpdatas
            .filter((e) => e.deviceid === showdata)
            .map((e) => {
              return (
                <div key={e.deviceid}>
                  <p>MAE : {e.MAE.toFixed(2)}</p>
                  <p>MAE_cal : {e.MAE_cal.toFixed(2)}</p>
                  <p>MAPE : {e.MAPE.toFixed(2)}</p>
                  <p>MAPE_cal : {e.MAPE_cal.toFixed(2)}</p>
                  <p>
                    R<sup>2</sup> : {e.R2.toFixed(2)}
                  </p>
                  <p>
                    R<sup>2</sup>_cal : {e.R2_cal.toFixed(2)}
                  </p>
                  <p>RMSE : {e.RMSE.toFixed(2)}</p>
                  <p>RMSE_cal : {e.RMSE_cal.toFixed(2)}</p>
                  <p>Calib Mean : {e.calib_mean.toFixed(2)}</p>
                  <p>Raw Mean : {e.raw_mean.toFixed(2)}</p>
                  <p>Ref Mean : {e.ref_mean.toFixed(2)}</p>
                  <p>Uptime Atmos : {e.uptime_atmos.toFixed(2)}</p>
                  <p>Uptime Ref : {e.uptime_ref.toFixed(2)}</p>
                  <p>
                    GET DATA :{" "}
                    <spam style={{ color: "rgb(15, 125, 50)" }}>
                      {messages.message === "successful" ? "SUCCESSFUL" : null}
                    </spam>
                  </p>
                </div>
              );
            })
        : [];
  } else if (messages.message === "unsuccessful") {
    return (
      <div
        className="row"
        style={{
          backgroundColor: "white",
          marginLeft: "0px",
          marginRight: "0px",
        }}
      >
        <div className="col-8">
          <Chart data1={chart} />
        </div>
        <div className="col-4 col align-self-center">
          <p>MAE : NA</p>
          <p>MAPE : NA</p>
          <p>MAPE_cal : NA</p>
          <p>
            R<sup>2</sup> : NA
          </p>
          <p>RMSE : NA</p>
          <p>Raw Mean : NA</p>
          <p>Ref Mean : NA</p>
          <p>Uptime Atmos : NA</p>
          <p>Uptime Ref : NA</p>
          <p>
            GET DATA :{" "}
            <spam style={{ color: "red" }}>
              {messages.message === "unsuccessful" ? "UNSUCCESSFUL" : null}
            </spam>
          </p>
        </div>
      </div>
    );
  } else {
    return startData;
  }

  return (
    <div>
      <div
        className="row mr-4 mt-4 ml-4 pb-4"
        style={{ backgroundColor: "white" }}
      >
        <div className="col-8">
          <Chart
            data1={chart}
            messsage={messages.message}
            download={props.download}
          />
        </div>
        <div className="col-4 col chart-graph-initial-text">
          <div className="top">
            <p className="head-text">Correlation Performance</p>
            <select
              className="custom-select-btn"
              value={showdata}
              onChange={handleDevice}
            >
              <option value="select">Select Device</option>
              {props.selectedOption.map((e) => (
                <option key={e.label}>{e.label}</option>
              ))}
            </select>
          </div>
          <div className="bottoms">
            {cpdatasRender}
            <button className="chart-graph-button" onClick={clearGraph}>
              <p>Clear Graph & Input</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
